import { render, staticRenderFns } from "./button-spinner.vue?vue&type=template&id=4fe6ef2a&scoped=true"
import script from "./button-spinner.vue?vue&type=script&lang=js"
export * from "./button-spinner.vue?vue&type=script&lang=js"
import style0 from "./button-spinner.vue?vue&type=style&index=0&id=4fe6ef2a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@2.1.1_webpack@4.47.0__lodash@4.17.21_vu_3eef67c0e1ef2ea3d089dafcd6c47d43/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe6ef2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/phuongle/Documents/MAV/deploy 1001/1001-optical-astro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe6ef2a')) {
      api.createRecord('4fe6ef2a', component.options)
    } else {
      api.reload('4fe6ef2a', component.options)
    }
    module.hot.accept("./button-spinner.vue?vue&type=template&id=4fe6ef2a&scoped=true", function () {
      api.rerender('4fe6ef2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/button-spinner.vue"
export default component.exports